import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingRotateImageConfig } from '@/data/landingConfig/landingRotateImageConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_RotateImage } from './schemaObject';

interface Props {}
const RotateImage: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_RotateImage} />
			<LandingTemplate
				data={landingRotateImageConfig}
				funnelLinkService={GenerateLandingLinkService.funnelFlipRotateImage()}
			/>
		</>
	);
};

export default RotateImage;
